export const instructorList = "INSTRUCTOR_LIST";
export const instructorCourseList = "INSTRUCTOR_COURSE_LIST";